export default "__VITE_ASSET___hSOHjiZ__"